import React, { FC, Fragment, useContext } from 'react';
import { getDatePickerFormat } from 'utils/format';
import { Box, Paper, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { DatePicker } from '@mui/x-date-pickers';
import { LabOrderContext } from 'pages/order-flow/lab-order/lab-order-context';
import SampleMethod from 'components/lab-order/sample-method/sample-method.component';
import { Sample } from 'models/order';

const SampleSection: FC = () => {
    const { t: translate } = useTranslation(['orders']);
    const { order, setOrder } = useContext(LabOrderContext);

    const handleReceivedDateChange = (date: Date | null) => {
        if (date) {
            setOrder((prev) => ({
                ...prev,
                sampleReceivedDate: date,
            }));
        }
    };

    const handleSampleSelection = (sample: Sample) => {
        setOrder((prev) => ({
            ...prev,
            sample,
        }));
    };

    return (
        <Fragment>
            <Paper variant="outlined" sx={{ padding: 2, marginBottom: 2, minHeight: '274px' }}>
                <Box mb={2}>
                    <Box>
                        <Typography variant="h4" mb={1}>
                            {translate('orders:WHEN_WAS_SAMPLE_RECEIVED_DATE')}
                        </Typography>
                    </Box>
                    <DatePicker
                        format={getDatePickerFormat()}
                        label={translate('DATE')}
                        maxDate={new Date()}
                        value={order.sampleReceivedDate}
                        onChange={handleReceivedDateChange}
                        slotProps={{
                            textField: {
                                fullWidth: true,
                                margin: 'dense',
                                inputProps: { 'data-test': 'sample-section.received-date' },
                            },
                        }}
                    />
                </Box>
                <Box>
                    <Box>
                        <Typography variant="h4" mb={1}>
                            {translate('orders:HOW_WAS_THE_SAMPLE_TAKEN')}
                        </Typography>
                    </Box>
                    <Box>
                        <SampleMethod
                            handleSampleSelection={handleSampleSelection}
                            sample={order.sample}
                            dataTest="sample-section.sample-method"
                        />
                    </Box>
                </Box>
            </Paper>
        </Fragment>
    );
};

export default SampleSection;
